import { Tab, Tabs } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useCurrentTab } from 'shared/hooks';

export function ApprovalActions() {
    const TIER_OVERRIDE_APPROVALS = 'customerTierOverride';
    const APPROVALS = 'approvals';
    const currentTab = useCurrentTab({
        orderedTabList: [TIER_OVERRIDE_APPROVALS, APPROVALS],
    });
    const [activeTab, setActiveTab] = useState(currentTab);

    const tabChange = useCallback((event, value: string) => {
        setActiveTab(value);
    }, []);

    useEffect(() => {
        if (activeTab !== currentTab) {
            setActiveTab(currentTab);
        }
    }, [activeTab, currentTab]);

    return (
        <Tabs
            value={activeTab}
            onChange={tabChange}
            textColor='secondary'
            indicatorColor='secondary'
            aria-label='Tier Override Approvals'
        >
            <Tab value={APPROVALS} label='Approvals' component={ReactRouterLink} to={ROUTES.approvals} />
            <Tab
                value={TIER_OVERRIDE_APPROVALS}
                label='Tier Override Approvals'
                component={ReactRouterLink}
                to={ROUTES.tierOverrideApprovals}
            />
        </Tabs>
    );
}
